import styled from 'styled-components';
/** A styled label component */
export const Label = styled.label `
  color: ${({ theme }) => theme.ColorTextHeadingOnWhite};
  display: block;
  font-weight: 500;
`;
//# sourceMappingURL=label.js.map